import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgSpanner = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m23.59 4.64-3.66 3.68-3.66-.4L15.59 4l3.6-3.64A6.6 6.6 0 0 0 17.08 0a6.85 6.85 0 0 0-4.9 2 7 7 0 0 0-1.67 7L1 18.67a2.5 2.5 0 0 0-1 1.65 2.76 2.76 0 0 0 1.17 1.81l.69.7A2.7 2.7 0 0 0 3.67 24a2.5 2.5 0 0 0 1.64-1l9.46-9.52A6.8 6.8 0 0 0 22 11.89a7 7 0 0 0 1.59-7.25m-18 16.2a1.71 1.71 0 0 1-2.41 0 1.72 1.72 0 1 1 2.43 0Z"
    }));
export default SvgSpanner;
